import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { tokenExpirado } from './utils/token.util.ts';

// Antes de montar qualquer coisa: se o token guardado ja venceu, descarta em
// silencio. Sem isto, os contexts saiam buscando com o token morto, o backend
// devolvia 401, e o apiService gravava "Sua sessao expirou" — entao quem so
// estava chegando para trabalhar levava um toast vermelho de erro sem ter feito
// nada. Como o JWT dura 2h e nao ha refresh, isso acontecia em toda volta.
//
// O aviso continua existindo para o caso em que ele ajuda: sessao que morre no
// meio do trabalho. La o apiService ja removeu o token antes de recarregar,
// entao `tokenExpirado(null)` da false e a mensagem sobrevive.
if (tokenExpirado(localStorage.getItem('token'))) {
  localStorage.removeItem('token');
  localStorage.removeItem('session_expired_message');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


